import { Add, Remove } from "@mui/icons-material";
import BazarButton from "components/BazarButton";
import { FlexBox } from "components/flex-box";
import { H3 } from "components/Typography";
import React from "react";

interface Props {
  max?: number;
  min?: number;
  value: number;
  disabled?: boolean;
  onChangeValue: (num: number) => void;
}

export const CounterButtons: React.FC<Props> = ({
  max = 99,
  min = 1,
  value,
  disabled,
  onChangeValue,
}) => {
  const onIncreasePress = () => {
    if (value === max) {
      return;
    }
    onChangeValue(value + 1);
  };

  const onDecreasePress = () => {
    if (value === min) {
      return;
    }
    onChangeValue(value - 1);
  };
  return (
    <FlexBox alignItems="center" mb={4.5} sx={{ opacity: disabled ? 0.5 : 1 }}>
      <BazarButton
        disabled={value <= min || disabled}
        size="small"
        sx={{ p: 1 }}
        color="primary"
        variant="outlined"
        onClick={onDecreasePress}
      >
        <Remove fontSize="small" />
      </BazarButton>

      <H3 fontWeight="600" mx={2.5}>
        {value || 0}
      </H3>

      <BazarButton
        disabled={value === max || disabled}
        size="small"
        sx={{ p: 1 }}
        color="primary"
        variant="outlined"
        onClick={onIncreasePress}
      >
        <Add fontSize="small" />
      </BazarButton>
    </FlexBox>
  );
};
